import { getTheme } from "../../../configs/themes";
import React from "react";
import { HiChevronDoubleLeft, HiChevronDoubleRight } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsActive,
  getIsSidebarSize,
  toggleChangeSidebarSize,
} from "../../../features/navbarSlice";

import { useNavigate } from "react-router-dom";
import { routes } from "../../../api/masterRoutes.js.js";
import { cn } from "../../../helpers/Common.js";
import { useUserStore } from "../../../pages/MasterWorkerPage/hooks/userStore";
import SidebarItem from "../../organisms/Navbar/Item";

const MainSidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isActive = useSelector(getIsActive);
  const isSidebarSize = useSelector(getIsSidebarSize);
  const user = useUserStore((state) => state.user);

  const theme = getTheme();

  return (
    <div
      className={`${isSidebarSize ? "min-w-[250px]" : "w-[70px]"} ${
        !isActive && "hidden"
      } fixed left-0 top-54 z-20 h-[93dvh] grid-cols-1 gap-16 overflow-scroll bg-white px-8 py-16 pb-16 md:relative md:top-0 md:grid md:h-full md:max-h-screen`}
    >
      <div className="relative grid h-full w-full grid-cols-1 grid-rows-[max-content,1fr] gap-12">
        <div className="right-[-16px] top-48 z-40 hidden md:absolute md:block ">
          <button
            className="w-fit rounded-l-16 border-1 border-dashed border-brand-primary bg-white p-4 pr-24 no-underline outline-none drop-shadow-md"
            onClick={() => dispatch(toggleChangeSidebarSize())}
          >
            {isSidebarSize && (
              <HiChevronDoubleLeft className="text-16 text-brand-primary" />
            )}
            {!isSidebarSize && (
              <HiChevronDoubleRight className="text-16 text-brand-primary" />
            )}
          </button>
        </div>

        <div className="relative flex h-fit w-full flex-col items-center justify-center">
          {isSidebarSize ? (
            <img
              src={theme.logoHorizontal}
              onClick={() => navigate(theme.defaultRoute)}
              className="h-auto w-[165px] cursor-pointer"
              alt="PT Semai Raya International"
            />
          ) : (
            <img
              src={theme.logoVertical}
              onClick={() => navigate(theme.defaultRoute)}
              className="w-[62px] cursor-pointer"
              alt="PT Semai Raya International"
            />
          )}
        </div>

        <div className="relative  flex max-h-full flex-col space-y-8 pb-16">
          {routes({ user })?.map((item, index) => {
            return (
              <SidebarItem
                key={index}
                item={item}
                icon={item.icon}
                activeIcon={item.activeIcon}
                title={item.title}
                linkTo={item.link}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MainSidebar;
